import { Fields, FieldType } from '@lyearn/form';
import { TFunction } from '@lyearn/i18n';

import { CaptionMap } from '../../types';
import { getLanguageItemRenderer, getLanguageItems } from './consts';
import { FormValues } from './types';

export const INITIAL_VALUES: FormValues = {
  language: '',
};

export const getFormFields = (t: TFunction, captionsState: CaptionMap): Fields<FormValues> => {
  return {
    language: {
      name: 'language',
      type: FieldType.Picklist,
      picklistValues: getLanguageItems(captionsState),
      props: {
        optionLabelRenderer: getLanguageItemRenderer,
        renderValue: getLanguageItemRenderer,
      },
      placeholder: t('Lygo:AdvancedMenu.video.Subtitles.selectPlaceholder'),
    },
  };
};

export const validateForm = (t: TFunction) => (values: FormValues) => {
  const errors: any = {};
  if (!values.language) {
    errors.language = t('Lygo:AdvancedMenu.video.Subtitles.selectError');
  }
  return errors;
};
